const ResultMeter = () => import(/* webpackChunkName: "resultMeter" */ './ResultMeter.vue')

const index = {
  path: 'meter/result',
  name: 'Result Meter',
  component: ResultMeter,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
